module.exports = __webpack_public_path__ + "img/step14_a_stand_power_fix_top_cross.795fb159.png";